import { render, staticRenderFns } from "./RecieptAdjustment.vue?vue&type=template&id=0b032462&"
import script from "./RecieptAdjustment.vue?vue&type=script&lang=js&"
export * from "./RecieptAdjustment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b032462')) {
      api.createRecord('0b032462', component.options)
    } else {
      api.reload('0b032462', component.options)
    }
    module.hot.accept("./RecieptAdjustment.vue?vue&type=template&id=0b032462&", function () {
      api.rerender('0b032462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/RecieptAdjustment.vue"
export default component.exports